import ShareButton from './share_button'
import { connect } from 'react-redux'
import { getShareProps } from 'lib/share'
import { hide } from 'redux/modules/toast_notification'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { TOAST_NOTIFICATIONS, POOL_TYPE } from 'shared/shared_consts'
import { campaignUrlWithMeDomain } from 'lib/campaign_url'
import { injectWorldReady } from '@paypalcorp/worldready-react'
import { generateShareMessage } from '../../../lib/generate_share_message'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  const isCopySuccess =
    state.toast_notification[TOAST_NOTIFICATIONS.COPY_SUCCESS]
  const shareProps = getShareProps(state, ownProps)
  const urlWithMeDomain = campaignUrlWithMeDomain(
    campaign.id,
    campaign.campaign_type
  )

  const { type, is_owner } = campaign
  const isSmallGroup = type === POOL_TYPE.PRIVATE

  const shareMessage = generateShareMessage(
    isSmallGroup,
    campaign,
    urlWithMeDomain,
    ownProps.worldReady
  )

  return {
    campaign,
    isCopySuccess,
    shareText: is_owner ? shareMessage : '',
    ...shareProps,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onHideToast() {
      dispatch(hide(TOAST_NOTIFICATIONS.COPY_SUCCESS))
    },
  }
}

export default injectWorldReady(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ShareButton)
)
